import { useState } from 'react';
import { X, Clock } from 'lucide-react';

interface Props {
  onClose: () => void;
  onConfirm: (iso: string) => void;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function defaultLocal(): string {
  const d = new Date(Date.now() + 60 * 60 * 1000);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default function ScheduleModal({ onClose, onConfirm }: Props) {
  const [value, setValue] = useState(defaultLocal());
  const [error, setError] = useState<string | null>(null);

  const submit = () => {
    if (!value) return setError('Укажите дату');
    const d = new Date(value);
    if (isNaN(d.getTime())) return setError('Неверный формат');
    if (d.getTime() <= Date.now() + 30_000) return setError('Время должно быть в будущем');
    onConfirm(d.toISOString());
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-surface-900 border border-surface-800 rounded-xl w-full max-w-sm p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-surface-100 font-semibold flex items-center gap-2"><Clock size={16} /> Запланировать отправку</h3>
          <button onClick={onClose} className="text-surface-500 hover:text-surface-200"><X size={18} /></button>
        </div>
        <input
          type="datetime-local"
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(null); }}
          className="irc-input w-full"
        />
        {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
        <div className="flex gap-2 mt-4">
          <button onClick={submit} className="btn-primary flex-1">Запланировать</button>
          <button onClick={onClose} className="btn-ghost flex-1">Отмена</button>
        </div>
      </div>
    </div>
  );
}
